import classnames from "classnames";
import React from "react";
import { useRenderOn } from "src/hooks";

import CorePicker from "../CorePicker";

import QuantitySelect from "./components/QuantitySelect";

function generateNumberArray(begin: number, end: number): number[] {
  const array: number[] = [];
  for (let i: number = begin; i <= end; i++) {
    array.push(i);
  }

  return array;
}

const numbers = generateNumberArray(0, 100);

interface IProps {
  className?: string;
  excludeZero?: boolean;
  onSelect: (quantity: number) => void;
  quantity: number;
  disabled?: boolean;
}

const QuantityPicker = ({
  className,
  excludeZero = false,
  onSelect,
  quantity,
  disabled,
}: IProps): JSX.Element => {
  const { mdOrDown } = useRenderOn();
  let numbersToDisplay = numbers;

  if (excludeZero) {
    numbersToDisplay = numbers.slice(1, numbers.length);
  }

  return mdOrDown ? (
    <CorePicker
      className={classnames("quantity-picker", className)}
      onSelect={onSelect}
      selectedValue={quantity}
      values={numbersToDisplay}
      disabled={disabled}
    />
  ) : (
    <QuantitySelect
      className={className}
      quantity={quantity}
      options={numbersToDisplay}
      onChange={onSelect}
    />
  );
};

export default QuantityPicker;
